import { observer } from 'mobx-react';
import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import { DefaultPageViewModel } from '../default-page.viewmodel';
import { EMBED_CODE_ID } from '../../../../../../../../modules/passport-pages/config';
import { FormField } from '../../../../../../../global/form/form-field/form-field';

type Props = {
    pageVm: DefaultPageViewModel;
};


export const ShowcasePageFields = observer(({ pageVm }: Props): JSX.Element => {
    const { formatMessage } = useIntl();

    const embedCodeId = pageVm.getFieldByKey(EMBED_CODE_ID);
    const embedCodeIdLabel = formatMessage(pageVm.getFieldConfigByKey(EMBED_CODE_ID).labelDescriptor);

    return (
        <>
            <FormField label={embedCodeIdLabel}>
                <div className='flex'>
                    <input
                        className='oe-form-field__control'
                        onBlur={pageVm.setValueTouched.bind(pageVm, EMBED_CODE_ID)}
                        value={embedCodeId.value as string || ''}
                        type='text'
                        onChange={e => pageVm.setFieldValueByKey(EMBED_CODE_ID, e.target.value)}
                    />
                </div>
                <span className='oe-form-field__error'>
                    {
                        !embedCodeId.valid && embedCodeId.touched &&
                        <FormattedMessage values={{ fieldName: embedCodeIdLabel }} {...embedCodeId.validationMessage} />
                    }
                </span>
            </FormField>
        </>
    );
});
